module.exports = __webpack_public_path__ + "static/media/facebook-d.cf980a46.svg";